<template>
  <div class="facebook-sign-in">
    <button class="fb-button" @click="onFacebookButtonClick">
      <span class="fb-logo">{{ adminText('adminAll.f_4a0a19', 'f') }}</span>
      <span class="fb-label">{{ (isAdminLocalization ? adminText('adminAll.facebook_sign_in_8170bd', 'Facebook Sign in') : $t('facebookLogin')) || adminText('adminAll.facebook_login_9f4876', 'Facebook login') }}</span>
    </button>
  </div>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
import { FacebookAuth } from '@/types'

export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'facebook-login',
  methods: {
    onFacebookButtonClick() {
      const appId = FacebookAuth.APP_ID
      const redirectUri =
        FacebookAuth.REDIRECT_URI || `${window.location.origin}/auth/facebook/callback`

      if (!appId) {
        // Fail silently in UI, but log for debugging
        // eslint-disable-next-line no-console
        console.error('Missing VUE_APP_FACEBOOK_APP_ID')

        return
      }

      const fullPath = `${window.location.pathname}${window.location.search}${window.location.hash}`
      const state = fullPath || '/'
      try {
        sessionStorage.setItem('coreevent_facebook_redirect_path', state)
      } catch (e) {
        // ignore
      }

      const baseUrl = 'https://www.facebook.com/v22.0/dialog/oauth'
      const params = new URLSearchParams({
        client_id: appId,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: FacebookAuth.SCOPE || 'email,public_profile',
        state,
      })

      window.location.href = `${baseUrl}?${params.toString()}`
    },
  },
}
</script>

<style scoped>
.facebook-sign-in {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fb-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #1877f2;
  background-color: #1877f2;
  color: #fff;
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.fb-button:hover {
  background-color: #1664d8;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.fb-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #fff;
  color: #1877f2;
  font-weight: 700;
  text-transform: lowercase;
}

.fb-label {
  white-space: nowrap;
}
</style>
